// French translations.
const fr = {
  ui: {
    brand: "My World Quest",
    brand_subtitle: "Colorier et Apprendre",
    nav: {
      home: "Accueil", countries: "Pays", globe: "Globe", continents: "Continents",
      color: "Colorier", puzzles: "Puzzles", games: "Jeux", quiz: "Quiz", parents: "Parents",
      math: "Géo Maths",
      "geo-lines": "Lignes du monde", "maths-academy": "Académie de Maths",
      more: "Plus",
      advanced: "Défis avancés",
      ask: "Demande au Globe ✨",
      campaigns: "Missions",
      "dream-trip": "Voyage de rêve",
      "hub-learn": "Explorer",
      "hub-create": "Créer",
      "hub-play": "Jouer",
      "hub-discover": "Aventure",
      knowledge: "Aventures thématiques",
      passport: "Mon passeport",
      stickers: "Autocollants",
      trip: "Voyage",
      "spelling-bee": "Concours d'orthographe",
      "mandala": "Studio Mandala",
      "admin-lessons": "Admin Leçons",
      "admin-questions": "Admin Banque de questions",
      "learning-plan": "Plan d'apprentissage",
      "term-report": "Rapport du trimestre",
      "teacher": "Tableau de l'enseignant",
      "quest-games": "Jeux de quête",
      "coloring": "Coloriage",
      "pixel-art": "Pixel Art",
      "flag-artist": "Artiste drapeau",
      "printables": "Fiches à imprimer",
      "play-home": "Site de jeu",
      "learn-topics": "Sujets d'apprentissage",
    },
    accessibility: { bigText: "Grand Texte", highContrast: "Contraste Élevé" },
    navGroups: { quick: "Rapide", explore: "Explorer", play: "Jouer & Apprendre", collect: "Collectionner", adv: "Aventure", grownup: "Pour les adultes" },
    actions: { back: "Retour", close: "Fermer", reset: "Réinitialiser", save: "Sauver", retry: "Réessayer", playAgain: "Rejouer" },
  },
  microcopy: {
    great: "Bravo ! ⭐",
    correct: "✅ Correct !",
    nope: "Essaie encore !",
    tryAgain: "Pas tout à fait. Continue !",
    awesome: "Super !",
    welcome: "Bienvenue en {{country}} ! Apprenons le {{language}}.",
    allPlaced: "Tous placés ! 🎉",
    youDidIt: "Tu as réussi !",
    perfect: "PARFAIT !",
  },
  home: {
    streak: "Série : {{n}} jour",
    streak_plural: "Série : {{n}} jours",
    subtitleShort: "Aider les enfants à explorer les pays, les cultures, les monuments et les continents à travers des aventures interactives.",
    tagline: "Du Temps d'Écran au Temps de Découverte",
    title1: "Explore le Monde",
    title2: "Un Pays à la Fois",
    subtitle: "Des aventures géographiques amusantes, des quiz, des défis et des récompenses pour aider les enfants à découvrir les pays, les cultures, les drapeaux, les monuments et plus encore.",
    playNow: "Jouer →",
    takeQuiz: "Faire un Quiz",
    countryOfTheDay: "🌟 Pays du Jour",
    discover: "Découvre {{name}} !",
    letsGo: "Allons-y",
    whatNext: "Que veux-tu faire aujourd'hui ?",
    whatNextSub: "Choisis ce que tu veux — tout est amusant !",
    tiles: {
      learn: "Apprendre les Pays", learnDesc: "Plus de 30 pays avec drapeaux !",
      globe: "Globe 3D", globeDesc: "Tourne et tape pour explorer",
      continents: "Continents", continentsDesc: "Explore les 7 continents",
      color: "Colorier", colorDesc: "Colorie la Tour Eiffel !",
      puzzles: "Puzzles", puzzlesDesc: "Puzzles à faire glisser et cartes",
      games: "Jouer", gamesDesc: "Associe pays et continents",
      quiz: "L'heure du Quiz", quizDesc: "Quiz facile et avancé",
      parents: "Pour les Parents", parentsDesc: "Voir les progrès de votre enfant",
    },
    stats: { stars: "Étoiles", countries: "Pays", badges: "Badges", streak: "Série" },
  },
  daily: {
    label: "Défi Quotidien",
    streakLabel: "Série {{n}}",
    todayDone: "Aujourd'hui terminé !",
    threeQuick: "3 questions rapides",
    descUnlocked: "Réponds à 3 questions pour 3 ⭐ + bonus de série (jusqu'à +5 ⭐).",
    descDone: "Tu as obtenu {{score}}. Reviens demain pour +1 ⭐ bonus !",
    start: "Commencer →",
    done: "Fini",
    finished: "Défi Terminé !",
    score: "Score :",
    streakSuffix: "jour",
    streakSuffix_plural: "jours",
    bonus: "(+{{n}} bonus !)",
  },
  learn: {
    title: "Apprendre les Pays 🌍",
    subtitle: "Clique sur une carte de pays pour en savoir plus. Touche le haut-parleur pour l'entendre !",
    searchPlaceholder: "Rechercher pays, capitale ou monument…",
    clear: "Effacer",
    filterAll: "Tous",
    hello: "Bonjour",
    capital: "Capitale", language: "Langue",
    learnedBtn: "Je l'ai appris ! ⭐",
    learnLang: "Apprendre langue",
    noResults: "Aucun pays trouvé. Essaie autre chose !",
    goalsEyebrow: "Objectifs d'Apprentissage du Jour",
    goalsHeading: "🎯 Concentre-toi sur ceux-ci",
    goalsSubtitle: "Les quatre choses les plus importantes à maîtriser à l'âge {{tier}} — choisies dans le programme.",
    goalsAllTopics: "Voir tous les sujets",
    goalsLearnNow: "Apprendre",
    goalsKey: "Clé n°{{n}}",
    topicTitles: {
      "art-design": "Dessin, Peinture et Design",
      "music": "Musique : Rythme, Chant et Notation",
      "computing-code": "Codage, Algorithmes et Sécurité en Ligne",
      "physical-education": "EPS, Santé et Fitness",
      "world-religions": "Religions et Croyances du Monde",
      "wellbeing-relationships": "Santé, Émotions et Amitiés",
    },
  },
  continents: {
    title: "Cartes des Continents 🗺️",
    subtitle: "Touche un continent pour découvrir ses pays et ses anecdotes !",
    countriesIn: "Pays en {{name}} :",
    learnMore: "Découvrir plus de pays →",
  },
  coloring: {
    title: "Colorier des Monuments 🎨",
    subtitle: "{{n}} monuments à colorier. Ou télécharge les fiches imprimables !",
    printOne: "Imprimer celui-ci",
    printAll: "Tout télécharger en PDF",
    tools: "Outils",
    colors: "Couleurs",
    fill: "Remplir", pencil: "Crayon", erase: "Gomme",
    undo: "Annuler", redo: "Refaire",
    sub: "Tape une tuile à côté de l'espace vide pour la faire glisser. Reconstruis {{name}} !",
  },
  games: {
    title: "Associe le Pays ! 🎮",
    subtitle: "Glisse (ou touche) un drapeau vers son continent.",
    newGame: "🔄 Nouvelle Partie",
    dragFlags: "Glisse ces drapeaux 👇",
  },
  quiz: {
    title: "L'heure du Quiz ! 🧠",
    subtitle: "Choisis un niveau. Tu vas y arriver !",
    basic: "Quiz Facile",
    advanced: "Quiz Avancé",
    basicDesc: "5 questions faciles sur les pays et les continents.",
    advancedDesc: "10 questions difficiles. Es-tu prêt ?",
    upTo: "Jusqu'à {{n}} ⭐",
    question: "Question {{i}} / {{n}}",
    backToMenu: "Retour au menu",
    perfect: "PARFAIT !",
    greatJob: "Bravo !",
    youGot: "Tu as",
    outOf: "sur",
  },
  parents: {
    title: "Tableau de Bord 👨‍👩‍👧",
    subtitle: "Suivez le parcours d'apprentissage de votre enfant.",
    parentsOnly: "Parents seulement",
    mathPrompt: "Répondez à cette question pour entrer.",
    unlock: "Déverrouiller",
    wrong: "Hmm, réessaie !",
    resetProgress: "Réinitialiser",
    resetConfirm: "Réinitialiser tous les progrès ? C'est irréversible.",
    badges: "Badges",
    recentActivity: "Activité Récente",
    noActivity: "Pas encore d'activité. À explorer !",
    notYet: "Pas encore",
    certTitle: "Certificat d'Exploration !",
    certBody: "Votre enfant a gagné {{stars}} étoiles et exploré {{countries}} pays.",
    printCert: "🖨️ Imprimer le Certificat",
    statsLabels: {
      stars: "Étoiles Gagnées", streak: "Série de Jours", countries: "Pays Appris",
      quizzes: "Quiz Faits", games: "Jeux Gagnés", coloring: "Pages Coloriées",
    },
  },
  lang: {
    title: "Apprendre le {{language}}",
    sub: "De {{country}} ! Touche une phrase pour l'entendre.",
    welcome: "Bienvenue",
    finish: "J'ai fini ! ⭐⭐",
    awesome: "Bel entraînement !",
    finishSub: "Termine la leçon pour gagner 2 étoiles.",
    tapToHear: "Touche pour entendre",
    speakTitle: "🎙️ Prononce le Mot",
    speakSubtitle: "Touche le micro et dis chaque phrase à voix haute !",
    speakUnsupported: "Le mode voix nécessite Chrome, Edge ou Safari iOS 14+.",
    listening: "J'écoute…",
    tapMic: "Touche le micro et dis :",
    wellDone: "Bien joué !",
    tryItAgain: "Essaie de le redire",
    youSaid: "Tu as dit :",
    expected: "Attendu :",
    phrases: {
      Hello: "Bonjour", "Thank you": "Merci", Goodbye: "Au revoir",
      Yes: "Oui", No: "Non", One: "Un", Two: "Deux", Three: "Trois",
    },
  },
  globe: {
    title: "Globe 3D 🌐",
    subtitle: "Tourne le monde. Les épingles brillantes sont des pays à découvrir. Les épingles dorées sont ceux que tu as appris !",
    learnedCounter: "{{n}} / {{total}} appris",
    spinTap: "Tourne et Touche !",
    spinTapSub: "Clique sur une épingle brillante pour découvrir un pays.",
    learnedTag: "⭐ Appris",
    moreInfo: "Plus d'infos →",
    learnLang: "🗣️ Apprendre la langue",
  },
  puzzles: {
    title: "Puzzles 🧩",
    subtitle: "Choisis un type de puzzle et joue !",
    sliding: "🖼️ Puzzle Coulissant",
    shape: "🗺️ Puzzle de Carte",
    placed: "{{done}} / {{total}} placés",
    tapPrompt: "Touche un drapeau, puis touche le bon endroit.",
    tapNext: "Maintenant touche le bon endroit →",
    moves: "Coups : {{n}}",
    best: "Meilleur : {{n}}",
    shuffle: "Mélanger",
    solvedIn: "🎉 Résolu en {{n}} coups !",
    newBest: "🏁 NOUVEAU RECORD en {{n}} coups !",
    record: "Ton record : {{n}} coups",
  },
  certificate: {
    title: "🎉 Grand Voyageur !",
    body: "Waouh ! Tu as appris {{n}} pays. Tu es un vrai Grand Voyageur !",
    print: "🖨️ Imprimer mon Certificat",
    keep: "Continuer à Explorer",
  },
  langSwitcher: {
    label: "Langue",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
  },
  common: {
    whereToNext: "Où aller ensuite ?",
    home: "Accueil",
    earnMoreStars: "⭐ Gagne plus d'étoiles",
    earnHowTo: "Joue à un jeu rapide — chacun donne de l'XP !",
    pickAge: "Choisir l'âge",
    ages: "Âges",
    startExploring: "Commencer l'exploration",
    pickAnywhere: "Choisis ci-dessus — ou clique ici !",
    tapAnyCountry: "Tape un pays pour découvrir son histoire !",
    exploreGlobe: "Explorer le Globe",
    exploreGlobeSub: "Aventure 3D plein écran",
  },
  shortcuts: {
    home: "Accueil",
    continents: "Continents",
    globe: "Globe",
    ask: "Demander",
    landmarks: "Monuments",
    flags: "Drapeaux",
    pixel: "Pixel",
    puzzles: "Puzzles",
    math: "Maths",
    trip: "Voyage",
    quiz: "Quiz",
    quests: "Quêtes",
    stickers: "Autocollants",
    miniGames: "Mini-jeux",
    geoMath: "Géo-Maths",
    quickQuiz: "Quiz Express",
    myTrophies: "Mes trophées",
    colorCreate: "Colorier",
    spinGlobe: "Faire tourner le globe",
    askGlobe: "Parle au globe",
    dreamTrip: "Voyage Imaginaire",
    earnStars: "Gagner des étoiles",
    tryAQuest: "Essaie une quête",
    playAgain: "Rejouer",
    learnCountry: "Apprendre un pays",
    colorLandmark: "Colorier un monument",
    learnCountries: "Apprendre les pays",
    advanced: "Mode Avancé",
    spellCountry: "Devine un pays",
    advancedHub: "Espace avancé",
    squishyHop: "Squishy Hop",
    mathSnap: "Math Snap",
    language: "Langue",
    geoLines: "Lignes du monde",
  },
  coloringExtra: {
    modeLandmarks: "Monuments",
    modeFlags: "Artiste de Drapeaux",
    modePixel: "Art Pixel",
    modeMandala: "Mandala",
    diffEasy: "Facile",
    diffMedium: "Moyen",
    diffExpert: "Expert",
    difficultyLabel: "Difficulté :",
  },
  tilesExtra: {
    labelLearn: "Apprendre",
    labelCreate: "Créer",
    labelPlay: "Jouer",
    labelTrophies: "Trophées",
    whatNextSub: "Choisis ce que tu veux — tout est amusant !",
  },
  pills: {
    orTry: "Ou essaie ↓",
    
    squishyHop: "Squishy Hop",
    mathSnap: "Snap maths",colorLandmark: "Colorier un monument",
    solvePuzzle: "Résous un puzzle",
    dreamTrip: "Voyage imaginaire",
    geoMath: "Essaie les géo-maths",
    continentQuests: "Quêtes par continent",
    stickerBook: "Album d'autocollants",
    famousPeople: "Personnes célèbres",
    culturalSpot: "Spot culturel",
    quickQuiz: "Quiz express",
    continentMaps: "Cartes continents",
    spellCountry: "Devine un pays",
    flagArtist: "Peintre de drapeaux",
    pixelArt: "Pixel art",
    spinGlobe: "Faire tourner le globe",
    askGlobe: "Parle au globe",
    myTrophies: "Mes trophées",
    advancedHub: "Espace avancé",
    geoLines: "Lignes du monde",
  },
  canvas: {
    tools: "Outils",
    brushSize: "Taille pinceau",
    colors: "Couleurs",
    patterns: "Motifs",
    modes: "Modes",
    solid: "Uni",
    anyColor: "Autre couleur",
    recent: "Récents",
    sticker: "Autocollant",
    symmetry: "Symétrie",
    colorByNumber: "Colorier par numéro",
    reference: "Référence",
    undo: "Annuler",
    redo: "Refaire",
    reset: "Effacer",
    replay: "Rejouer",
    check: "Vérifier",
    save: "Enregistrer",
    fill: "Remplir",
    pencil: "Crayon",
    stamp: "Tampon",
    erase: "Gomme",
    on: "ON",
    off: "OFF",
    tool: "Outil :",
    pattern: "motif :",
    printOne: "Imprimer",
    downloadAll: "Tout télécharger",
    appTitle: "Colorier et Créer 🎨",
    appSub: "Pinceaux, motifs, autocollants, coloriage par numéro & plus !",
  },
};

export default fr;
